import { createContext, useContext } from "react"

export const GameContext = createContext({
    score: 0,
    setScore: () => {},
    currentSong: null,
    setCurrentSong: () => {},
    answerContext: null,
    setAnswerContext: () => {},
    songIndex: 0,
    setSongIndex: () => {},
    songsContext: null,
    setSongsContext: () => {}
})

/* export const OptionsContext = createContext({
    optionsContext: JSON.parse(localStorage.getItem('options')),
    setOptionsContext: () => {},

}) */